import * as actionTypes from 'app-redux/actionTypes'

export const setMaxCompanies = (payload) => {
  return {
    type: actionTypes.SET_MAX_COMPANIES,
    payload,
  }
}
